<template>
  <v-dialog
    v-model="dialog"
    width="50%"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-form ref="form" v-model="valid" @submit.prevent="submit()">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <alert-message></alert-message>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="form.userName"
                  label="User Name"
                  type="text"
                  readonly
                  disabled
                  :error-messages="[]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="form.oldPassword"
                  label="Enter Current Password"
                  type="password"
                  :error-messages="
                    [].concat(
                      fieldErrors('form.oldPassword'),
                      serverSideErrors('OldPassword')
                    )
                  "
                  @blur="$v.form.oldPassword.$touch()"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="form.newPassword"
                  label="Password"
                  type="password"
                  :error-messages="
                    [].concat(
                      fieldErrors('form.newPassword'),
                      serverSideErrors('NewPassword')
                    )
                  "
                  @blur="$v.form.newPassword.$touch()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="form.confirmNewPassword"
                  label="Confirm Password"
                  type="password"
                  :error-messages="fieldErrors('form.confirmNewPassword')"
                  @blur="$v.form.confirmNewPassword.$touch()"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="dialog = false">Cancel</v-btn>
          <v-btn
            :disabled="$v.$invalid"
            type="submit"
            color="info"
            :loading="loading"
          >
            Change Password
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import UTIL from "src/helpers/utility";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import AlertMessage from "src/components/AlertMessage";
import { isCombinationString } from "src/utils/helpers";
import { helpers, required, sameAs, minLength } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";

export default {
  components: {
    AlertMessage,
  },
  props: {
    item: [Object, String],
    show: [Boolean, String],
  },
  mixins: [validationMixin],
  validations: {
    form: {
      oldPassword: {
        required,
      },
      newPassword: {
        required,
        minLength: minLength(8),
        valid: function (value) {
          return !helpers.req(value) || isCombinationString(value);
        },
      },
      confirmNewPassword: {
        required,
        sameAsPassword: sameAs("newPassword"),
      },
    },
  },
  validationMessages: {
    form: {
      oldPassword: {
        required: "Please enter password",
      },
      newPassword: {
        required: "Please enter password",
        minLength: "Password must be of 8 characters",
        valid: "Please use combination password",
      },
      confirmNewPassword: {
        required: "Required",
        sameAsPassword: "Password does not match",
      },
    },
  },

  data() {
    return {
      showDialog: this.show,

      form: {
        id: "",
        userName: "",
        email: "",
        password: "",
        phoneNumber: "",
        firstName: "",
        lastName: "",
        address: "",
        city: "",
        state: "",
        zipcode: "",
      },

      dialog: false,
      valid: false,
      loading: false,
    };
  },

  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },
    dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
    },
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
      alert: (state) => state.alert,
    }),
    formTitle() {
      return "Change Admin Password";
    },
    isEdit() {
      return UTIL.gv(this.item, "id", "") ? true : false;
    },
  },

  created() {},

  methods: {
    ...mapActions("account", ["changeAdminPassword"]),
    serverSideErrors(field) {
      return UTIL.gv(this.account.errors, field, []);
    },
    onDialogClose() {
      if (this.isEdit) {
        //
      } else {
        //
      }
      this.$emit("onClosed");
    },
    onDialogOpen() {
      this.$nextTick(() => {
        // clear error state
        this.$store.dispatch("alert/clear");
        this.$v.$reset();
      });
      this.form = {
        ..._.pick(this.item, _.keys(this.form)),
      };
    },
    save() {},
    addNew() {
      this.dialog = true;
      this.form = {
        id: "",
        password: "",
        repeatPassword: "",
      };
    },

    completed() {
      this.$emit("onSucceded");
    },

    async submit() {
      this.loading = true;
      if (!this.valid) {
        this.$store.dispatch("snackbar/error", "Form invalid");
        return false;
      }

      let payload = {
        username: this.form.userName,
        oldPassword: this.form.oldPassword,
        newPassword: this.form.newPassword,
        confirmNewPassword: this.form.confirmNewPassword,
      };

      await this.changeAdminPassword(payload);

      if (!this.account.status.error) {
        this.dialog = false;
        this.completed();
      }
      this.loading = false;
    },
  },
};
</script>